import { useFeatureFlags } from "context";
import { LicenseProps } from "types";
import { Collapsable } from "ui-atoms";
import { joinArray } from "utils";

type LicensePreviewProps = {
  licenses?: LicenseProps[];
};
const LicensePreview = ({ licenses }: LicensePreviewProps) => {
  const { newProfileView } = useFeatureFlags();
  if (!licenses || licenses.length === 0) {
    return newProfileView ? (
      <p className="text-sm text-jll-text-base-subdued">
        No license information available.
      </p>
    ) : null;
  }
  return (
    <div className="flex flex-col space-y-4">
      {licenses?.map((license: LicenseProps, idx) => (
        <Collapsable
          label={`License Information - ${joinArray(
            [
              license?.individual_state_licensed || "",
              license?.individual_license_number || "",
            ],
            " | "
          )}`}
          key={license?.individual_license_number || idx}
        >
          <div>
            <div className="border-b border-b-jll-stroke-default-1 py-3">
              <p>Individual License</p>
              <div className="grid grid-cols-2 mt-2">
                <div className="col-span-1 text-sm mb-3">
                  <p className="text-jll-text-base-subdued mb-1">
                    License number
                  </p>
                  <p>{license?.individual_license_number}</p>
                </div>
                <div className="col-span-1 text-sm mb-3">
                  <p className="text-jll-text-base-subdued mb-1">Type</p>
                  <p>{license?.individual_license_type}</p>
                </div>
                <div className="col-span-1 text-sm mb-3">
                  <p className="text-jll-text-base-subdued mb-1">Location</p>
                  <p>{license?.individual_state_licensed}</p>
                </div>
                <div className="col-span-1 text-sm mb-3">
                  <p className="text-jll-text-base-subdued mb-1">Phone</p>
                  <p>{license?.individual_office_phone}</p>
                </div>

                <div className="col-span-2 text-sm mb-3">
                  <p className="text-jll-text-base-subdued mb-1">Address</p>
                  <p>{license?.individual_office_address}</p>
                </div>
              </div>
            </div>
            <div className="py-3">
              <p>Entity License</p>
              <div className="grid grid-cols-2 mt-2">
                <div className="col-span-1 text-sm mb-3">
                  <p className="text-jll-text-base-subdued mb-1">
                    License number
                  </p>
                  <p>{license?.legal_entity_license}</p>
                </div>
                <div className="col-span-1 text-sm mb-3">
                  <p className="text-jll-text-base-subdued mb-1">Name</p>
                  <p>
                    {license?.legal_entity_name}, {license?.legal_entity_suffix}
                  </p>
                </div>
                <div className="col-span-1 text-sm mb-3">
                  <p className="text-jll-text-base-subdued mb-1">Phone</p>
                  <p>{license?.main_office_phone}</p>
                </div>

                <div className="col-span-1 text-sm mb-3">
                  <p className="text-jll-text-base-subdued mb-1">Address</p>
                  <p>{license?.main_office_address}</p>
                </div>
              </div>
            </div>
          </div>
        </Collapsable>
      ))}
    </div>
  );
};

export default LicensePreview;
